import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyCucJTkAaU_b5-eZMIQfOuzRM9dt6sV410",
  authDomain: "hardwarepakistan-7463e.firebaseapp.com",
  databaseURL: "https://hardwarepakistan-7463e.firebaseio.com",
  projectId: "hardwarepakistan-7463e",
  storageBucket: "hardwarepakistan-7463e.appspot.com",
  messagingSenderId: "93883077507",
  appId: "1:93883077507:web:12b5094e81e7e83d5ddcb6",
  measurementId: "G-0C9HFDP0YW",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
